var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGraphicFour3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 360,
    viewBox: "0 0 361 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M180.67 359.83C81.46 359.83 0.75 279.12 0.75 179.92C0.75 80.72 81.46 0 180.67 0C279.88 0 360.58 80.71 360.58 179.92C360.58 279.13 279.87 359.83 180.67 359.83ZM180.67 2C82.57 2 2.75 81.81 2.75 179.92C2.75 278.03 82.56 357.83 180.67 357.83C278.78 357.83 358.58 278.02 358.58 179.92C358.58 81.82 278.77 2 180.67 2Z",
    fill: "url(#paint0_linear_229_416)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_229_416",
    x1: 270.61,
    y1: 24.13,
    x2: 90.73,
    y2: 335.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D46D1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D46D1",
    stopOpacity: 0.0144
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#8D46D1",
    stopOpacity: 0.1225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8D46D1",
    stopOpacity: 0.3025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8D46D1",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8D46D1",
    stopOpacity: 0.7056
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#8D46D1",
    stopOpacity: 0.8649
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8D46D1",
    stopOpacity: 0.9604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D46D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGraphicFour3);
export default __webpack_public_path__ + "static/media/circle-graphic-four-3.fad3839244f9007e05551d80f82190e4.svg";
export { ForwardRef as ReactComponent };